(function () {
  if (window.__musayoRecesso) return;
  window.__musayoRecesso = true;

  var root = document.querySelector('[data-recesso-form]');
  if (root) {
    var form = root.closest('form');
    var step1 = root.querySelector('[data-recesso-step="1"]');
    var step2 = root.querySelector('[data-recesso-step="2"]');
    var next = root.querySelector('[data-recesso-next]');
    var back = root.querySelector('[data-recesso-back]');
    var summary = root.querySelector('[data-recesso-summary]');
    var body = root.querySelector('[data-recesso-body]');
    var error = root.querySelector('[data-recesso-error]');

    function value(name) {
      var field = form.querySelector('[name="' + name + '"]');
      return field ? field.value.trim() : '';
    }

    function showError(message) {
      if (!error) return;
      error.hidden = !message;
      error.textContent = message || '';
    }

    function declaration(stamp) {
      return [
        'Dichiarazione di recesso dal contratto',
        'Nome: ' + value('contact[name]'),
        'Numero d’ordine: ' + value('contact[order]'),
        'Email per la conferma: ' + value('contact[email]'),
        stamp ? 'Data e ora di invio: ' + stamp : '',
        'Dichiaro di recedere dal contratto di vendita dell’ordine indicato.'
      ]
        .filter(Boolean)
        .join('\n');
    }

    function stampNow() {
      var when = new Date();
      var pretty = new Intl.DateTimeFormat('it-IT', {
        timeZone: 'Europe/Rome',
        dateStyle: 'full',
        timeStyle: 'medium'
      }).format(when);
      return pretty + ' (' + when.toISOString() + ')';
    }

    if (next) {
      next.addEventListener('click', function () {
        var email = value('contact[email]');
        if (!value('contact[name]') || !value('contact[order]') || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showError(root.getAttribute('data-invalid'));
          return;
        }
        showError('');
        var text = declaration('');
        if (summary) summary.textContent = text;
        if (body) body.value = text;
        step1.hidden = true;
        step2.hidden = false;
        var confirm = step2.querySelector('[type="submit"]');
        if (confirm) confirm.focus();
      });
    }

    if (back) {
      back.addEventListener('click', function () {
        step2.hidden = true;
        step1.hidden = false;
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        if (step2.hidden) {
          event.preventDefault();
          if (next) next.click();
          return;
        }
        var stamped = declaration(stampNow());
        if (body) body.value = stamped;
        if (summary) summary.textContent = stamped;
        try {
          sessionStorage.setItem(
            'musayo-recesso-receipt',
            JSON.stringify({ text: stamped, at: Date.now() })
          );
        } catch (e) {}
      });
    }
  }

  function readReceipt() {
    try {
      return JSON.parse(sessionStorage.getItem('musayo-recesso-receipt') || 'null');
    } catch (e) {
      return null;
    }
  }

  var saved = readReceipt();
  var success = document.querySelector('[data-recesso-success]');
  if (success) {
    var receipt = success.querySelector('[data-recesso-receipt]');
    if (saved && saved.text && receipt) receipt.textContent = saved.text;
    return;
  }

  var posted = /(?:^|[?&])contact_posted=true(?:&|$)/.test(location.search);
  var fresh = saved && saved.text && saved.at && Date.now() - saved.at < 10 * 60 * 1000;
  if (!posted || !fresh) return;

  var main = document.getElementById('MainContent');
  if (!main) return;

  var box = document.createElement('div');
  box.className = 'page-width page-width--narrow musayo-recesso';
  var title = document.createElement('h1');
  title.textContent = 'Ricevuta di recesso';
  var pre = document.createElement('pre');
  pre.className = 'musayo-recesso__receipt';
  pre.setAttribute('data-recesso-receipt', '');
  pre.textContent = saved.text;
  var note = document.createElement('p');
  note.textContent =
    'La ricevuta riporta il testo della dichiarazione, con data e ora di invio. Lo stesso testo è arrivato a MUSA&yo. Conserva questa pagina o salva la ricevuta.';
  box.appendChild(title);
  box.appendChild(pre);
  box.appendChild(note);
  main.insertBefore(box, main.firstChild);
})();
